import * as angular from 'angular';
import { gpDataApp } from './app';

gpDataApp.run([function () {

}]);
